// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-BH-","colBig":"styles_colBig__1i_-w","colSmall":"styles_colSmall__3VjoB","shopifyNameWrapper":"styles_shopifyNameWrapper__31ae9"};